<template>
    <div>
        <h3 class="is-size-3">Indicadores para Puntaje Crediticio</h3>
        <p>
            <code>POST {{ host }}/api/firaCreditScore</code>
        </p>
        <br />
        <h5 class="is-size-6">El endpoint recibe dos parámetros obligatorios:</h5>
        <div class="content">
            <ul>
                <li>
                    <strong>anexo</strong>
                    <ul>
                        <li>Obligatorio</li>
                        <li>Anexo a consultar (21 o 22)</li>
                    </ul>
                </li>
                <li>
                    <strong>industria_grupo</strong>
                    <ul>
                        <li>Obligatorio</li>
                        <li>Numerico</li>
                    </ul>
                </li>
            </ul>
        </div>
        <br />
        <h5 class="is-size-6">
            El endpoint recibe la solicitud en formato JSON:
        </h5>
        <pre>
        <code>
        {
            "anexo": 21,
            "industria_grupo": 1
        }
        </code>
        </pre>
        <br />
        <h5 class="is-size-6">Respuesta:</h5>
        <pre>
        <code>
            [
                {
                    "id_indicador_grupo": 1,
                    "factor_riesgo": "I-A",
                    "indicador": "Porcentaje de pagos en tiempo con entidades financieras bancarias en los últimos 12 meses.",
                    "caracteristica_buro": "BK12_PCT_PROMT",
                    "params": {},
                    "value": null
                },
                {
                    "id_indicador_grupo": 2,
                    "factor_riesgo": "I-A",
                    "indicador": "Porcentaje de pagos en tiempo con entidades financieras no bancarias en los últimos 12 meses.",
                    "caracteristica_buro": "NBK12_PCT_PROMT",
                    "params": {},
                    "value": null
                },
                {
                    "id_indicador_grupo": 3,
                    "factor_riesgo": "I-B",
                    "indicador": "Máximo número de atrasos presentado en los últimos 7 meses considerando el mes de calificación.",
                    "caracteristica_buro": null,
                    "params": {
                        "months": 7
                    },
                    "value": "atraso"
                },
                {
                    "id_indicador_grupo": 4,
                    "factor_riesgo": "I-B",
                    "indicador": "Porcentaje de saldo sin días de atraso con la Institución en los últimos 4 meses considerando el mes de calificación.",
                    "caracteristica_buro": null,
                    "params": {
                        "months": 4
                    },
                    "value": "porcentajeSaldoSinAtraso"
                },
                {
                    "id_indicador_grupo": 5,
                    "factor_riesgo": "I-C",
                    "indicador": "Rendimiento sobre capital (ROE)",
                    "caracteristica_buro": null,
                    "params": {
                        "sinInformacion": "NA"
                    },
                    "value": "sinInformacion"
                },
                {
                    "id_indicador_grupo": 6,
                    "factor_riesgo": "I-C",
                    "indicador": "Periodo de cobro a deudores",
                    "caracteristica_buro": null,
                    "params": {
                        "sinInformacion": "NA"
                    },
                    "value": "sinInformacion"
                },
                {
                    "id_indicador_grupo": 7,
                    "factor_riesgo": "I-C",
                    "indicador": "Razón de efectivo a activo total",
                    "caracteristica_buro": null,
                    "params": {
                        "sinInformacion": "NA"
                    },
                    "value": "sinInformacion"
                },
                {
                    "id_indicador_grupo": 8,
                    "factor_riesgo": "I-C",
                    "indicador": "Razón de cobertura de interés",
                    "caracteristica_buro": null,
                    "params": {
                        "sinInformacion": "NA"
                    },
                    "value": "sinInformacion"
                }
            ]
        </code>
        </pre>
        <hr />
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style lang="scss" scoped>
</style>